import {AfterViewInit, Component, HostListener, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {PageTitleService} from '../core/page-title/page-title.service';
import {ChkService} from '../shared/services/chk.service';
import {Subscription} from 'rxjs';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {DataService} from '../shared/services/data.service';
import {CommonModule, isPlatformBrowser, ViewportScroller} from '@angular/common';
import { HeaderComponent } from 'app/core/header/header.component';
import { Footer2Component } from 'app/core/footer2/footer2.component';
import { MenuComponent } from 'app/menu/menu.component';
import set = Reflect.set;

declare var $: any;

@Component({
  selector: 'angly-layout',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: true,
  imports: [ CommonModule, RouterModule, HeaderComponent, Footer2Component, MenuComponent ]
})
export class MainComponent implements OnInit, AfterViewInit {

  private _router: Subscription;
  url: string;
  private _mediaSubscription: Subscription;
  private _routerEventsSubscription: Subscription;
  isHome = true;
  isBlog = false;
  isCommon = false;
  fixedHeaderClass = false;

  /* Variables */
  headerTitle: string;
  headerSubTitle: string;
  featuredPost: any;

  constructor(
    private pageTitleService: PageTitleService,
    private service: ChkService,
    public router: Router,
    private viewportScroller: ViewportScroller,
    @Inject(PLATFORM_ID) private platformId
  ) {

    /* page title.*/
    this.pageTitleService.title.subscribe((val: string) => {
      this.headerTitle = val;
    });

    /* page subTitle. */
    this.pageTitleService.subTitle.subscribe((val: string) => {
      this.headerSubTitle = val;
    });

    this.service.getFeaturedPost().subscribe(response => {
        this.featuredPost = response;
      },
      err => console.log(err),
      () => this.featuredPost
    );
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          document.body.scrollTo(0, 0);
          this.viewportScroller.scrollToPosition([0, 0]);
          this.insertCustomThemeColors(DataService.getData().theme['5'].colors);
        }, 100);
      }
    });
  }

  ngAfterViewInit() {
    this.insertCustomThemeColors(DataService.getData().theme['5'].colors);
  }

  insertCustomThemeColors(colors) {
    document.body.style.backgroundColor = colors.background;
    document.body.style.color = colors.textBody;
    Array.from(document.querySelectorAll('h1')).forEach((el) => el.style.color = colors.textH1);
    Array.from(document.querySelectorAll('h2')).forEach((el) => el.style.color = colors.textH2);
    Array.from(document.querySelectorAll('h3')).forEach((el) => el.style.color = colors.textH3);
    Array.from(document.querySelectorAll('h4')).forEach((el) => el.style.color = colors.textH4);
  }

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    if (event.path && (event.path[0].scrollTop > 0)) {
      this.fixedHeaderClass = true;
    } else {
      this.fixedHeaderClass = false;
    }
  }

  onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
    // window.scroll(0, 0);
  }

  addToggleClass() {
    $('body').toggleClass('rtl-enable');
  }

}
